import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-incident-list__player as-d-flex as-flex-1" }
const _hoisted_2 = { class: "as-incident-list__player-info as-d-flex as-align-items-center" }
const _hoisted_3 = { class: "as-incident-list__player-logo as-cursor-pointer" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "as-incident-list__player-name as-d-flex as-flex-column" }


const __default__ = {};

interface Props {
  name?: string;
  img?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayerItem',
  props: {
    name: { default: 'N/A' },
    img: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "as-rounded-pill as-incident-list__player-logo--in as-player-avatar as-bg-white",
          src: _ctx.img || _ctx.getImgUrlBySport('player', 'default', true, 'football'),
          alt: _ctx.name
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
    ])
  ]))
}
}

})